import React from 'react';
import styled from 'styled-components';
import { Fill } from 'layout-core-components';

import Spinner from './Spinner';

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const WrappedSpinner = () => (
  <Fill to="parent">
    <Wrapper>
      <Spinner />
    </Wrapper>
  </Fill>
);

export default WrappedSpinner;
